import * as React from 'react';

function NavSearch(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 128 128"
            {...props}
        >
            <path
                d="M89.41,74.71A42.62,42.62,0,1,0,75,89.08l25.73,25.74a10.18,10.18,0,0,0,14.37,0h0a10.16,10.16,0,0,0,0-14.37ZM53.06,79A26.3,26.3,0,1,1,79.38,52.74h0A26.34,26.34,0,0,1,53.06,79Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default NavSearch;
